<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormLayout
          :errors="errors"
          :company-id="portalCompany.attributes.company_id"
          :content-article-categories="contentArticleCategories"
          :content-article-labels="contentArticleLabels"
          :content-article-flags="contentArticleFlags"
          :portal="portal"
          :initial="initial"
          :portals="portals"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import FormLayout from '../../../../../../../../components/Administration/ContentArticles/Layouts/Form'
import LoadingContainer from '../../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {FormLayout, LoadingContainer},

  props: {
    portal: {
      required: true
    },

    portalCompanyId: {
      required: true
    }
  },

  data() {
    return {
      portalCompany: null,
      contentArticleCategories: null,
      contentArticleLabels: null,
      contentArticleFlags: null,
      portals: null,

      loading: true,

      errors: {},

      initial: {
        content_bodies: [
          {body_category: 'text', body_category_parameters: {}}
        ],
        content_article_tags: [],
        content_article_flag_schedules: [],
        content_article_references: [],
        publish_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        copies: {}
      }
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/portal-companies/' + this.portalCompanyId),
        http.getList('/api/v2/content-article-categories'),
        http.get('/api/v2/content-article-labels', {'filter[portal_id]': this.portal.id}),
        http.get('/api/v2/content-article-flags', {'filter[portal_id]': this.portal.id}),
        http.get('/api/v2/portals'),
      ]).then(responses => {
        this.portalCompany = responses[0].data.data

        this.contentArticleCategories = responses[1]

        this.contentArticleLabels = responses[2].data.data

        this.contentArticleFlags = responses[3].data.data

        this.portals = responses[4].data.data

        this.loading = false

      })
    },

    submit(data) {
      http.post('/api/v2/content-articles', {
        ...data,
        portal_company_id: this.portalCompanyId,
        copies: Object.entries(data.copies).filter(entry => entry[1]).map(entry => ({content_article_category_id: entry[1]}))
      })
          .then(() => {
            notify.success('The content article was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/articles')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
